module.exports = __webpack_public_path__ + "components/country-flag/static/mc-2aa8e16a6b580b87517a9829d864f713.svg";